import { delay } from "@/lib/mockUtils";

export const resetPasswordMock = async (token: string, newPassword: string) => {
  console.log("Mock: Resetting password for token:", token, "with new password:", newPassword);
  await delay(1000); // Simulate network delay
  // Simulate success for any valid token/password for now
  return Promise.resolve();
};
